import { useEffect } from "react";
import { convertToURLObj } from "../../utils/convertSharedFilterData";
export const useFiltersShare = (params) => {
    const { mapPosition, selectedFilters, isFiltersSharingEnabled } = params;
    useEffect(() => {
        if (isFiltersSharingEnabled && window) {
            const url = new URL(window.location.href);
            url.search = new URLSearchParams(convertToURLObj(mapPosition, selectedFilters)).toString();
            window.history.replaceState({}, "", url);
        }
    }, [mapPosition, selectedFilters, isFiltersSharingEnabled]);
};
//# sourceMappingURL=useFiltersShare.js.map